import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { qcTemplatesQueryOptions, WorkflowTemplateCreatePage } from '@/features/workflows';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/workflows/new')({
  staticData: { crumb: 'workflows:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.write');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...qcTemplatesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: WorkflowTemplateCreatePage,
});
